/* eslint-disable camelcase */
export class InvoicePlanTemplate {
	constructor({
		id,
		name,
		description,
		quantity,
		interval,
		price,
		prices
	} = {}) {
		this._id = id;
		this._name = name;
		this._description = description;
		this._quantity = quantity;
		this._interval = interval;
		this._price = price || 0;
		this._prices = prices || [];
	}

	getKey() {
		return String(this._id);
	}

	getId() {
		return this._id;
	}

	getName() {
		return this._name || 'custom';
	}

	getDescription() {
		return this._description;
	}

	getQuantity() {
		return this._quantity;
	}

	getPrice() {
		return this._price;
	}

	getPrices() {
		return this._prices;
	}

}

class InvoicePlan {
	constructor({
		id,
		start_date,
		end_date,
		quantity,
		template,
		interval,
		price
	} = {}) {
		this._id = id;
		this._start_date = start_date || null;
		this._end_date = end_date || null;
		this._quantity = quantity || 0;
		this._template = template || null;
		this._interval = interval || null;
		this._price = price || 0;
	}

	getKey() {
		return String(this._id);
	}

	getId() {
		return this._id;
	}

	getStartDate() {
		return this._start_date ? new Date(this._start_date) : null;
	}

	getEndDate() {
		return this._end_date ? new Date(this._end_date) : null;
	}

	getQuantity() {
		return this._quantity;
	}

	getInterval() {
		return this._interval;
	}

	getDaysInterval() {
		const interval = this._interval.split(' ');
		return interval.length ? parseInt(interval[0]) : 0;
	}

	getPrice() {
		return this._price;
	}

	getTemplate() {
		return this._template ? new InvoicePlanTemplate(this._template) : null;
	}

}
export default InvoicePlan;
